<template>
  <div>   
    <v-layout class=" py-4">
        <v-container grid-list-xl>
            <v-row>
                 <v-col sm="5" cols="12">
                    <v-card 
                        flat="" 
                        color="primary"  >
                        <v-img
                            :src="'/images/teresian/t4.JPG'"
                            :lazy-src="not.imgLazy"
                            height="150px"
                            dark>
                            <v-overlay absolute=""> 
                                <v-layout fill-height="" class="white--text " >
                                    <div class="not-f8 ">TERESIAN SISTERS</div>
                                </v-layout>
                            </v-overlay> 
                        </v-img>
                        <DIV class="pa-2 white--text not-f3 font-weight-bold">OUR CONTACT DETAILS:</DIV>
                        <v-list two-line subheader="">
                            <v-subheader>Sr. Teresa Mulenga</v-subheader>
                            <v-list-item link="">
                                <v-list-item-icon>
                                    <v-icon color="primary">phone</v-icon>
                                </v-list-item-icon> 
                                <v-list-item-content>
                                    <v-list-item-subtitle>Phone number</v-list-item-subtitle> 
                                    <v-list-item-title>+265 992974102</v-list-item-title>
                                </v-list-item-content> 
                                <v-list-item-icon>
                                    <v-icon>mdi-message-text</v-icon>
                                </v-list-item-icon>
                            </v-list-item>
                            <v-divider inset></v-divider>
                            <v-list-item link="">
                                <v-list-item-icon>
                                    <v-icon color="primary">email</v-icon>
                                </v-list-item-icon> 
                                <v-list-item-content>
                                    <v-list-item-subtitle>Email address</v-list-item-subtitle>  
                                    <v-list-item-title>teresa.mulenga@yahoo.com</v-list-item-title>
                                </v-list-item-content> 
                                <!-- <v-list-item-icon>
                                    <v-icon>mdi-message-text</v-icon>
                                </v-list-item-icon> -->
                            </v-list-item>
                            <v-divider inset></v-divider>
                            <v-list-item link="">
                                <v-list-item-icon>
                                    <v-icon color="primary">mdi-account-question</v-icon>
                                </v-list-item-icon> 
                                <v-list-item-content>
                                    <v-list-item-subtitle>Position</v-list-item-subtitle>  
                                    <v-list-item-title>Web Manager</v-list-item-title>
                                </v-list-item-content> 
                                <!-- <v-list-item-icon>
                                    <v-icon>mdi-message-text</v-icon>
                                </v-list-item-icon> -->
                            </v-list-item> 

                            <v-subheader>Sr. Agnes Jonas</v-subheader>
                            <v-list-item link="">
                                <v-list-item-icon>
                                    <v-icon color="primary">phone</v-icon>
                                </v-list-item-icon> 
                                <v-list-item-content>
                                    <v-list-item-subtitle>Phone number</v-list-item-subtitle> 
                                    <v-list-item-title>+265 999 95 74 40</v-list-item-title>
                                </v-list-item-content> 
                                <v-list-item-icon>
                                    <v-icon>mdi-message-text</v-icon>
                                </v-list-item-icon>
                            </v-list-item>
                            <v-divider inset></v-divider>
                            <v-list-item link="">
                                <v-list-item-icon>
                                    <v-icon color="primary">email</v-icon>
                                </v-list-item-icon> 
                                <v-list-item-content>
                                    <v-list-item-subtitle>Email address</v-list-item-subtitle>  
                                    <v-list-item-title>jonas2@gmail.com</v-list-item-title>
                                </v-list-item-content> 
                                <!-- <v-list-item-icon>
                                    <v-icon>mdi-message-text</v-icon>
                                </v-list-item-icon> -->
                            </v-list-item>
                            <v-divider inset></v-divider>
                            <v-list-item link="">
                                <v-list-item-icon>
                                    <v-icon color="primary">mdi-account-question</v-icon>
                                </v-list-item-icon> 
                                <v-list-item-content>
                                    <v-list-item-subtitle>Position</v-list-item-subtitle>  
                                    <v-list-item-title>Superior General</v-list-item-title>
                                </v-list-item-content>  
                            </v-list-item> 
                            <v-layout align-center="" justify-center="" class="my-2">
                                <v-btn to="/about/sisters" color="primary" text outlined="">Our team</v-btn> 
                            </v-layout>
                           
                        </v-list> 
                    </v-card>
                </v-col>


                <v-col sm="7" cols="12">
                    <div class="not-f8 font-weight-bold">Contact Us</div>
                    <div>
                        Fill out the form below and we will get back to you.
                    </div>

                    <form id="loginForm" class="py-5" @submit.prevent="onSubmit()">
                        <div v-if="response.type">
                            <v-alert :type="response.type" >
                                <ul>
                                    <div v-for="(item, index) in response.res" :key="index">
                                        <li >{{item}}</li> 
                                    </div>
                                </ul>
                            </v-alert> 
                        </div>
                        <v-row class="pt-5"> 
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field  required 
                                    background-color="primary lighten-5" 
                                    @input="formRes()"
                                    type="name"
                                    v-model="input.first_name"
                                    label="First name"
                                    filled=""
                                    clearable
                                    id="firt_name"
                                ></v-text-field>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field  required 
                                    background-color="primary lighten-5" 
                                    @input="formRes()"
                                    type="name"
                                    v-model="input.last_name"
                                    label="Last name"
                                    filled=""
                                    clearable
                                ></v-text-field>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field   required
                                    background-color="primary lighten-5" 
                                    @input="formRes()"
                                    type="email"
                                     v-model="input.email"
                                    label="Email address"
                                    filled=""
                                    clearable
                                ></v-text-field>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field  required 
                                    background-color="primary lighten-5" 
                                    @input="formRes()"
                                    type="number"
                                    v-model="input.phoneNumber"
                                    label="Phone number"
                                    filled=""
                                    clearable
                                ></v-text-field>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="12">
                                <v-text-field  required
                                    background-color="primary lighten-5" 
                                    @input="formRes()"
                                    type="name"
                                    v-model="input.subject"
                                    label="Subject of your message"
                                    filled=""
                                    clearable
                                ></v-text-field>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="12">
                                <v-textarea aria-required=""  
                                    background-color="primary lighten-5" 
                                    @input="formRes()" 
                                    v-model="input.message"
                                    filled=""
                                    clearable
                                ></v-textarea>
                            </v-col>
                        </v-row>
                        <v-layout row wrap class="px-3">
                            <v-spacer></v-spacer>
                            <v-btn color="primary" :loading="input.loading" rounded="" type="submit">Send <v-icon class="pl-3">send</v-icon></v-btn>
                        </v-layout>
                    </form>

                </v-col> 
            </v-row> 
        </v-container> 
    </v-layout> 
  </div> 
</template>

<script>
 
let pageName = "Contact"
    export default {
        name:pageName,
        props:["not"],
        data() {
        return {
            page_show:false,
            dialogMessage: false,
            load:false,
            input:{
                first_name:'',
                last_name:'',
                email:'',
                phoneNumber:'',
                subject:'',
                message:'',
                loading:false,
            },
            response:{
                type:"",
                res:[], 
            },
            images:[
                {src:'/images/teresian/t4.JPG',local:true},  
            ] 
        }
        },
        created() {
            this.EventBus.$on('notYesDialog', this.notYesDialog);
        },
        mounted() {
            this.not.NotHeaderNT({
                notShow:true,
                notType:"map",
                notText:false,
                notIndicators:true,
                notHeight:"500",
                notImages:this.images
            })
        },
        computed: {
            us(){ 
                return this.not.us
            }, 
            loading(){  
                return this.not.loading
            },
            processes(){  
                return this.not.processes
            }, 
            responses(){  
                return this.not.responses
            },
        },
        methods: {
            notYesDialog(){
                this.input = {}
                this.formRes()
            }, 
            onSubmit(){
                this.input.loading = true
                this.formRes()
                if (!this.input.first_name) {
                    this.formRes("error","First name is required")
                }
                if (!this.input.last_name) {
                    this.formRes("error","Last name is required")
                }
                if (!this.input.email) {
                    this.formRes("error","Email is required")
                }
                if (!this.input.phoneNumber) {
                    this.formRes("error","Phone is required")
                }
                if (!this.input.subject) {
                    this.formRes("error","Subject is required")
                }
                if (!this.input.message) {
                   this.formRes("error","Message is required")
                }

                if(this.response.res.length == 0) {
                    this.$store.dispatch("fi_add_Message",this.input) 
                }else{
                    //this.input.loading = false 
                }
                
            },
            formRes(type,res){
                this.input.loading = false
                if (type) {
                    this.response.type=type
                    if (res) {
                        this.response.res.push(res)
                    } 
                }else{
                    this.response = {
                        type:"",
                        res:[], 
                    }
                }
                
            },
            //LOAD
            pageLoad(t){
                if (!t) {
                    t=400
                }
                setTimeout(()=>{
                    let us = this.loggedUser 
                    let ps = this.processes
                    let ld = this.loading
                    let res = this.responses
                    //this.page_show = false 

                    //CHECK USER STATE
                    if (ps.indexOf('logging')!==-1) { 
                    } else {  
                    } 

                    //Check Message 
                    if (ps.indexOf('add/message')!==-1) {
                        this.not.notDialogP(true,true,'Sending...')
                        this.input.loading = true
                    }else{
                        this.not.notDialogP(false)
                        this.input.loading = false
                    }  

                    //check response
                    if (res.res==='add/message/successful') {
                        this.formRes()
                        this.formRes("success","Message, successfuly sent.")
                        this.not.notDialog(true,true,'Successful','Message, successfuly sent.','','OK','')
                        this.input.loading = false
                        this.not.notDialogP(false) 

                    }else if (res.res==='add/message/error'){
                        this.formRes()
                        this.formRes("error","Error while sending message.")
                        this.not.notDialog(true,true,'Not Successful','Error while sending message.','','OK','')
                        this.input.loading = false
                        this.not.notDialogP(false)
                    }
                },t)
            }
            
        },
        watch: {
            input(v){
                this.formRes()
            },
            loading(value){
                this.pageLoad(1)
            },
            processes(value){
                this.pageLoad(1)
            },
            responses(value){
                this.pageLoad(1) 
            } 
        },
  }
</script>
 
